import React, { useState } from 'react';
import { Modal, Radio, Space } from 'antd';
import { ReactComponent as WinrarIcon } from '@/assets/svg/winrar.svg';

interface ExportConfirmModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (convertToPdf: boolean) => void;
  loading?: boolean;
}

const ExportConfirmModal: React.FC<ExportConfirmModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  loading = false
}) => {
  const [exportFormat, setExportFormat] = useState<'original' | 'pdf'>('original');

  const handleOk = () => {
    const convertToPdf = exportFormat === 'pdf';
    onConfirm(convertToPdf);
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      title="导出格式"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="确定"
      cancelText="取消"
      confirmLoading={loading}
      width={400}
    >
      <div style={{ padding: '16px 0' }}>
        <div style={{ marginBottom: '16px' }}>
          <span style={{ fontWeight: 500 }}>导出格式：</span>
        </div>
        
        <Radio.Group
          value={exportFormat}
          onChange={(e) => setExportFormat(e.target.value)}
        >
          <Space direction="horizontal" size={24}>
            <Radio value="original">保持原格式</Radio>
            <Radio value="pdf">word转成PDF</Radio>
          </Space>
        </Radio.Group>
        
        <div style={{ 
          marginTop: '20px', 
          padding: '12px', 
          backgroundColor: '#f6f6f6', 
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <WinrarIcon style={{ width: '24px', height: '24px' }} />
          <span style={{ color: '#666' }}>
            即将导出项目资料包压缩包，是否确认导出？
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default ExportConfirmModal;
